let OSS = require('ali-oss');
import moment from 'moment';
import VueCookies from 'vue-cookies';
import getPlatformURL from '../config/platformBaseURL';

let isNorth = VueCookies.get('pc_back_paltformType') == 1;
let client = isNorth
  ? new OSS({
      region: 'oss-cn-beijing',
      accessKeyId: 'LTAI5tKrQP61hhDcgjBi5xWB',
      accessKeySecret: 'SR8rXvJUG83vJ1QV7XFySHxATIRPss',
      bucket: 'unicom-eigpay-north'
    })
  : new OSS({
      region: 'oss-cn-shenzhen',
      accessKeyId: 'LTAI4G9gCb9k5LKkyKGG9Taf',
      accessKeySecret: 'bOy5awk9Yk1Yq0pIHiES2o2O2UosTG',
      bucket: 'unicom-eigpay-south'
    });

/**
 存储空间名称：unicom-eigpay
 一级目录：项目id（projectId）
 二级目录：子系统（sysName ）+模块名称（bucketName ）+ (环境 dev uat prd) 
 三级目录：年月（time）
 一级二级三级之间用“/”即可实现，例如 projectId + "/" + sysName + "-" + bucketName + "/" + time + "/" + imageName
 */
async function uplaodImage(projectId, imageData, pictureName, systermName, moduleName) {
  let systerm = systermName;
  let bucketName = moduleName;
  let envienment = getEnvironment();
  let currentDate = new Date();
  let timeDate = moment(currentDate).format(`YYYYMM`);
  let uploadPath = `${projectId}/${systerm}-${bucketName}-${envienment}/${timeDate}/${pictureName}`;
  return client.put(uploadPath, imageData);
}

function getEnvironment() {
  let currentURL = getPlatformURL();
  if (currentURL == 'http://unicom.eigpay.com') {
    return 'dev';
  } else if (currentURL == 'http://182.92.67.139') {
    return 'uat';
  } else if (
    currentURL == 'http://182.92.163.166' ||
    currentURL == 'http://120.76.140.79:81' ||
    currentURL == 'http://101.201.56.242' ||
    currentURL == 'https://cbg.gongjiangcloud.cn'
  ) {
    return 'prd';
  }
  return '';
}

export default uplaodImage;
